import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";

export enum EXPORT_FORMATS {
  PDF = "pdf",
  XLSX = "xlsx",
}

export const EXPORT_FORMATS_LIST: {
  [key in EXPORT_FORMATS]: {
    label: string;
    icon: JSX.Element;
  };
} = {
  [EXPORT_FORMATS.PDF]: {
    label: "PDF",
    icon: <PictureAsPdfIcon />,
  },
  [EXPORT_FORMATS.XLSX]: {
    label: "XLSX",
    icon: <GridOnIcon />,
  },
};
